"use client";
'use strict';

var useRollbarConfiguration = require('./useRollbarConfiguration.js');

function useRollbarPerson(person) {
  useRollbarConfiguration.useRollbarConfiguration({
    payload: {
      person: person
    }
  });
}

exports.useRollbarPerson = useRollbarPerson;
//# sourceMappingURL=useRollbarPerson.js.map
